import { PRIVATE_ROUTE } from './routes';
import { SIDEBAR_TYPE as TYPE } from '../components/sections/sidebar/constants';
import ForbiddenError from '../pages/errors/403';
import NotFoundError from '../pages/errors/404';
import InternalServerError from '../pages/errors/500';
import AssistantListPage from '../pages/private/assistant/AssistantListPage';
import AssistantOverviewPage from '../pages/private/assistant/AssistantOverviewPage.jsx';
import AssistantSettingsPage from '../pages/private/assistant/AssistantSettingsPage.jsx';
import CustInstOverviewPage from '../pages/private/custom-inst/CustInstOverviewPage';
import CustomInstSettingsPage from '../pages/private/custom-inst/CustomInstSettingsPage';
import ProjectCustInstListPage from '../pages/private/custom-inst/ProjectCustInstListPage';
import ServerFileEditorPage from '../pages/private/gps/ServerFileEditorPage';
import ServerFileManagerPage from '../pages/private/gps/ServerFileManagerPage';
import ServerJobsDetailsPage from '../pages/private/gps/ServerJobsDetailsPage';
import ServerJobsPage from '../pages/private/gps/ServerJobsPage';
import ServerMonitoringPage from '../pages/private/gps/ServerMonitoringPage.jsx';
import ServerOverviewPage from '../pages/private/gps/ServerOverviewPage';
import ServerSettingsPage from '../pages/private/gps/ServerSettingsPage';
import ModelOverviewPage from '../pages/private/model/ModelOverviewPage';
import ModelSettingsPage from '../pages/private/model/ModelSettingsPage';
import ProjectModelListPage from '../pages/private/model/ProjectModelListPage';
import AdminImageAssetsPage from '../pages/private/other/AdminImageAssetsPage';
import ExtensionDetailsPage from '../pages/private/other/ExtensionDetailsPage';
import ExtensionLibraryPage from '../pages/private/other/ExtensionLibraryPage';
import UserAccountSettingsPage from '../pages/private/other/UserAccountSettingsPage';
import UserProfilePage from '../pages/private/other/UserProfilePage';
import BillingPage from '../pages/private/project/billing-page/BillingPage';
import NewProjectPage from '../pages/private/project/NewProjectPage';
import ProjectBackupPage from '../pages/private/project/ProjectBackupPage';
import ProjectCrawlerDetailsPage from '../pages/private/project/ProjectCrawlerDetailsPage';
import ProjectCrawlerStatusDetailsPage from '../pages/private/project/ProjectCrawlerJobStatusPage';
import ProjectCrawlerPage from '../pages/private/project/ProjectCrawlerPage';
import ProjectInstanceListPage from '../pages/private/project/ProjectInstanceListPage';
import ProjectMemberInvitationPage from '../pages/private/project/ProjectMemberInvitationPage';
import ProjectMemberPage from '../pages/private/project/ProjectMemberPage';
import ProjectOverviewPage from '../pages/private/project/ProjectOverviewPage';
import ProjectRestorePage from '../pages/private/project/ProjectRestorePage';
import ProjectServerListPage from '../pages/private/project/ProjectServerListPage';
import ProjectSettingsPage from '../pages/private/project/ProjectSettingsPage';
import ProjectsPage from '../pages/private/project/ProjectsPage';
import ProjectSubsExtension from '../pages/private/project/ProjectSubsExtensions';
import ProjectSynonymDictionariesPage from '../pages/private/project/ProjectSynonymDictionariesPage';
import ProjectSynonymDictionaryPage from '../pages/private/project/ProjectSynonymDictionaryPage';
import NewInstancePage from '../pages/private/solr/NewInstancePage';
import SolrCollectionPage from '../pages/private/solr/SolrCollectionsPage';
import SolrConfigPage from '../pages/private/solr/SolrConfigPage';
import SolrFileEditorPage from '../pages/private/solr/SolrFileEditorPage';
import SolrFileManagerPage from '../pages/private/solr/SolrFileManagerPage';
import SolrHealthCheckPage from '../pages/private/solr/SolrHealthCheckPage';
import SolrMonitoringPage from '../pages/private/solr/SolrMonitoringPage';
import SolrOverviewPage from '../pages/private/solr/SolrOverviewPage';
import SolrSearchPage from '../pages/private/solr/SolrSearchPage';
import SolrSettingsPage from '../pages/private/solr/SolrSettingsPage';

const PAGE_ROUTES = {
  private: [
    {
      path: PRIVATE_ROUTE.ADMIN_IMAGE_ASSETS,
      element: <AdminImageAssetsPage />,
    },
    {
      path: PRIVATE_ROUTE.USER_PROFILE,
      element: <UserProfilePage />,
      layoutProps: { sidebar: TYPE.USER },
    },
    {
      path: PRIVATE_ROUTE.USER_ACCOUNT,
      element: <UserAccountSettingsPage />,
      layoutProps: { sidebar: TYPE.USER },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_NEW,
      element: <NewProjectPage />,
    },
    {
      path: PRIVATE_ROUTE.PROJECTS,
      element: <ProjectsPage />,
    },
    {
      path: PRIVATE_ROUTE.PROJECT_MEMBER_INVITATION,
      element: <ProjectMemberInvitationPage />,
    },
    {
      path: PRIVATE_ROUTE.EXTENSIONS,
      element: <ExtensionLibraryPage />,
    },
    {
      path: PRIVATE_ROUTE.EXTENSION_DETAILS,
      element: <ExtensionDetailsPage />,
    },
    {
      path: PRIVATE_ROUTE.PROJECT_OVERVIEW,
      element: <ProjectOverviewPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_MEMBER,
      element: <ProjectMemberPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_BILLING,
      element: <BillingPage />,
      layoutProps: { sidebar: TYPE.PROJECT, requireAdmin: true },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_BACKUP,
      element: <ProjectBackupPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_RESTORE,
      element: <ProjectRestorePage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_SUBS_EXTENSIONS,
      element: <ProjectSubsExtension />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_SYNONYM_DICTIONARIES,
      element: <ProjectSynonymDictionariesPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_SYNONYM_DICTIONARY,
      element: <ProjectSynonymDictionaryPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_CRAWLER,
      element: <ProjectCrawlerPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_CRAWLER_DETAILS,
      element: <ProjectCrawlerDetailsPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_CRAWLER_JOB_STATUS,
      element: <ProjectCrawlerStatusDetailsPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_SETTINGS,
      element: <ProjectSettingsPage />,
      layoutProps: { sidebar: TYPE.PROJECT, requireAdmin: true },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_NEW,
      element: <NewInstancePage />,
      layoutProps: { sidebar: TYPE.PROJECT, requireAdmin: true },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_INSTANCE_LIST,
      element: <ProjectInstanceListPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_OVERVIEW,
      element: <SolrOverviewPage />,
      layoutProps: { sidebar: TYPE.INSTANCE },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_COLLECTIONS,
      element: <SolrCollectionPage />,
      layoutProps: { sidebar: TYPE.INSTANCE },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_CONFIG,
      element: <SolrConfigPage />,
      layoutProps: { sidebar: TYPE.INSTANCE },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_FILE_MANAGER,
      element: <SolrFileManagerPage />,
      layoutProps: { sidebar: TYPE.INSTANCE },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_FILE_EDITOR,
      element: <SolrFileEditorPage />,
      layoutProps: { sidebar: TYPE.INSTANCE },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_HEALTH_CHECK,
      element: <SolrHealthCheckPage />,
      layoutProps: { sidebar: TYPE.INSTANCE },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_SEARCH,
      element: <SolrSearchPage />,
      layoutProps: { sidebar: TYPE.INSTANCE },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_MONITORING,
      element: <SolrMonitoringPage />,
      layoutProps: { sidebar: TYPE.INSTANCE },
    },
    {
      path: PRIVATE_ROUTE.INSTANCE_SETTINGS,
      element: <SolrSettingsPage />,
      layoutProps: { sidebar: TYPE.INSTANCE, requireAdmin: true },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_GPS_LIST,
      element: <ProjectServerListPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.GPS_OVERVIEW,
      element: <ServerOverviewPage />,
      layoutProps: { sidebar: TYPE.GPS },
    },
    {
      path: PRIVATE_ROUTE.GPS_JOBS,
      element: <ServerJobsPage />,
      layoutProps: { sidebar: TYPE.GPS },
    },
    {
      path: PRIVATE_ROUTE.GPS_JOBS_DETAILS,
      element: <ServerJobsDetailsPage />,
      layoutProps: { sidebar: TYPE.GPS },
    },
    {
      path: PRIVATE_ROUTE.GPS_FILE_MANAGER,
      element: <ServerFileManagerPage />,
      layoutProps: { sidebar: TYPE.GPS },
    },
    {
      path: PRIVATE_ROUTE.GPS_FILE_EDITOR,
      element: <ServerFileEditorPage />,
      layoutProps: { sidebar: TYPE.GPS },
    },
    {
      path: PRIVATE_ROUTE.GPS_SETTINGS,
      element: <ServerSettingsPage />,
      layoutProps: { sidebar: TYPE.GPS, requireAdmin: true },
    },
    {
      path: PRIVATE_ROUTE.GPS_MONITORING,
      element: <ServerMonitoringPage />,
      layoutProps: { sidebar: TYPE.GPS },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_MODEL_LIST,
      element: <ProjectModelListPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.MODEL_OVERVIEW,
      element: <ModelOverviewPage />,
      layoutProps: { sidebar: TYPE.MODEL },
    },
    {
      path: PRIVATE_ROUTE.MODEL_SETTINGS,
      element: <ModelSettingsPage />,
      layoutProps: { sidebar: TYPE.MODEL },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_CUSTOM_INST_LIST,
      element: <ProjectCustInstListPage />,
      layoutProps: { sidebar: TYPE.PROJECT },
    },
    {
      path: PRIVATE_ROUTE.CUSTOM_INST_OVERVIEW,
      element: <CustInstOverviewPage />,
      layoutProps: { sidebar: TYPE.CUSTOM_INST },
    },
    {
      path: PRIVATE_ROUTE.CUSTOM_INST_SETTINGS,
      element: <CustomInstSettingsPage />,
      layoutProps: { sidebar: TYPE.CUSTOM_INST },
    },
    {
      path: PRIVATE_ROUTE.PROJECT_ASSISTANT_LIST,
      element: <AssistantListPage />,
      layoutProps: { sidebar: TYPE.ASSISTANT },
    },
    {
      path: PRIVATE_ROUTE.ASSISTANT_OVERVIEW,
      element: <AssistantOverviewPage />,
      layoutProps: { sidebar: TYPE.ASSISTANT },
    },
    {
      path: PRIVATE_ROUTE.ASSISTANT_SETTINGS,
      element: <AssistantSettingsPage />,
      layoutProps: { sidebar: TYPE.ASSISTANT, requireAdmin: true },
    },
    {
      path: PRIVATE_ROUTE.ERROR403,
      element: <ForbiddenError />,
    },
    {
      path: PRIVATE_ROUTE.ERROR404,
      element: <NotFoundError />,
    },
    {
      path: PRIVATE_ROUTE.ERROR500,
      element: <InternalServerError />,
    },
  ],
};

export default PAGE_ROUTES;
